/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import * as RegistrationConstants from './RegistrationConstants';
import * as AppConstants from '../../../SharedModule/Utils/AppConstants';
import ErrorMessages from '../../../SharedModule/MessageHandlers/ErrorMessages';
import SuccessMessage from '../../../SharedModule/MessageHandlers/SuccessMessage';
import { ResendEmailActions } from '../Store/Actions/RegistrationActions';
import moment from 'moment';
import Spinner from '../../../SharedModule/Spinner/Spinner';

export default function RegistrationSuccessForm(props) {
    const dispatch = useDispatch();
    let successMessagesArray = [];
    let errorMessagesArray = [];
    // eslint-disable-next-line no-unused-vars
    const [registrationData, setRegistrationData] = React.useState(
        props.location.state && props.location.state.registrationValue
            ? props.location.state.registrationValue
            : []
    );
    const [errorMessages, setErrorMessages] = React.useState([]);
    const [successMessages, setSuccessMessages] = React.useState([]);
    const [spinnerLoader, setSpinnerLoader] = React.useState(false);
    // Dispatch Actions
    const resendEmailDispatch = (resendEmailCriteria) => dispatch(ResendEmailActions(resendEmailCriteria));

    const resendEmailData = useSelector(state => state.registrationState.resendEmail);

    useEffect(() => {
        if (resendEmailData) {
            setSpinnerLoader(false);
            errorMessagesArray = [];
            setErrorMessages([]);
            errorMessagesArray = AppConstants.handleAPIErrors(resendEmailData, errorMessagesArray, RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
            if (errorMessagesArray && errorMessagesArray.length > 0) {
                setErrorMessages(errorMessagesArray);
            } else if (resendEmailData.id || resendEmailData.status === AppConstants.SUCCESS) {
                successMessagesArray.push(RegistrationConstants.RESEND_EMAIL_SUCCESS);
                setSuccessMessages(successMessagesArray);
            } else {
                errorMessagesArray.push(RegistrationConstants.REGISTRATION_TECHNICAL_ERROR);
                setErrorMessages(errorMessagesArray);
            }
        }
    }, [resendEmailData]);

    // Method to resend Email
    const handleResendEmail = () => {
        const resendEmailRequest = {
            userId: registrationData.userID ? registrationData.userID : '',
            firstName: registrationData.firstName ? registrationData.firstName : '',
            lastName: registrationData.lastName ? registrationData.lastName : '',
            email: registrationData.emailAddress ? registrationData.emailAddress : '',
            dob: registrationData.dob ? moment(registrationData.dob).format('YYYY-MM-DD') : ''
        };
        setSpinnerLoader(true);
        resendEmailDispatch(resendEmailRequest);
    }

    return (
        <div className="container">
            {spinnerLoader ? <Spinner /> : null}
            <div className="success-alert-container">
                {errorMessages && errorMessages.length > 0 ?
                    <ErrorMessages errorMessages={errorMessages} /> : null}
                {errorMessages && successMessages && errorMessages.length === 0 && successMessages.length > 0 ?
                    <SuccessMessage successMessages={successMessages} /> : null}
            </div>
            <div className="contact-us-block-success font-weight-600">
                <a href="/contactUs" target="_blank">Contact Us</a>
                <span className="blue-font px-1">|</span>
                <a href="/Help" target="_blank">Help</a>
            </div>
            <div className="success-container">
                <div className="">
                    <img src="Successfully_submitted.svg" className="mx-auto d-block" alt="Successfully Submitted" />
                    <h6 className="text-center font-weight-bold my-3">Congratulations!</h6>
                    <p className="text-center px-lg-5 pb-0 m-0">You have successfully registered for web access. </p> 
                    <p className="text-center px-lg-5 pt-0 m-0 mb-3">You will receive a confirmation of your registration containing your one-time password via the email 
                        you entered. 
                    </p>
                    <p className="text-center px-lg-5 m-0 mb-5">Please login to continue.</p>
                    <div className="button-wrapper">
                        <Button className='btn-primary btn-dialog' onClick={handleResendEmail}>
                            Resend Email </Button>
                        <Button className='btn-transparent btn-dialog' onClick={() => AppConstants.backToLogin(props)}>
                            Login </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}
